import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
import { PAGE_HEADER_BLOCK_CONFIG, PAGE_HEADER_VERSION_CONFIG } from '../../layout/page/header/page-header.config';
export const PAGE_MENU_TAB_PREFERENCE_FIELD = <NICmsContentField.IChoiceField>{
    type: NICmsContentField.EFieldType.choice,
    key: 'additional.menuTabPreference',
    title: 'Menu Tab Preference',
    options: () => {
        const blockModels = window['app']?.resources?.block?.getAllExisting();
        if (blockModels?.length) {
            const pageHeader = blockModels.find(i => i?.data?.url === PAGE_HEADER_BLOCK_CONFIG.block?.url);
            if (pageHeader) {
                const tabs = pageHeader.data?.content?.menuTabs;
                if (tabs?.length) {
                    return tabs
                        .map(tab => {
                            if (tab.id && tab.text) {
                                return {
                                    key: tab.id,
                                    title: tab.text
                                };
                            }
                        })
                        .filter(i => !!i);
                }
            }
        }
        return [];
    }
};

ICmsContentService.registerPageMetaPatch(pageMeta => {
    const designTab = 'Design';
    pageMeta.fields?.push(...PAGE_HEADER_VERSION_CONFIG, PAGE_MENU_TAB_PREFERENCE_FIELD);
});
